export const calculateMarginMapper = (data) => {
    let result = {};
    if (data) {
        result.exposure_margin = data.exMgn;
        result.prm = data.prm;
        result.span_margin = data.spMgn;
        result.total = data.tot;
    }
    return result;
};
